import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { Overline, Section } from "../components/UI";
import { SEO } from "../components/SEO";
import NotFound from "./NotFound";
import { APPROVED_CONDITIONS } from "../data/approvedConditions";

// The /conditions gallery renders exclusively from the approved static
// source. No dynamic DB fetch. No hidden-slug filter. Unapproved,
// duplicate or seeded Condition records cannot appear here.

export function ConditionsHub() {
  return (
    <div>
      <SEO />
      <Section>
        <Overline>Conditions</Overline>
        <h1 className="font-serif text-4xl md:text-6xl text-navy mt-3 tracking-tight leading-none">
          A connected medical knowledge base.
        </h1>
        <p className="text-lg text-stone2 mt-5 max-w-2xl">
          Every condition on this platform is linked to symptoms, investigations, treatments, guidelines and related articles — so the picture is always complete.
        </p>

        <div className="mt-10">
          <Overline>Deep-Dive Resource</Overline>
          <div className="h-px w-10 bg-prestige my-4" />
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="conditions-gallery">
            {APPROVED_CONDITIONS.map((c) => (
              <Link
                key={c.slug}
                to={c.route}
                data-testid={c.testid}
                className="block bg-white border border-line p-6 hover:shadow-md hover:-translate-y-0.5 transition-[transform,box-shadow] duration-300 group"
              >
                <h3 className="font-serif text-2xl text-navy leading-tight group-hover:underline underline-offset-4">
                  {c.title}
                </h3>
                <p className="text-sm text-stone2 mt-3 line-clamp-3">
                  {c.cardDescription}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </Section>
    </div>
  );
}

// The generic `/conditions/:slug` route no longer renders any Condition
// detail page. It exists only to:
//   1. Permanently redirect the legacy `/conditions/recurrent-pregnancy-loss`
//      URL to the approved dedicated page at `/recurrent-pregnancy-loss`.
//   2. Return the site's standard 404 for every other slug so removed
//      seeded records cannot render.
export function ConditionDetail() {
  const { slug } = useParams();
  if (slug === "recurrent-pregnancy-loss") {
    return <Navigate to="/recurrent-pregnancy-loss" replace />;
  }
  return <NotFound />;
}
